import styled, { css } from 'styled-components'
import { rgba } from 'polished'
import { ReactComponent as SymbolIcon } from 'icons/circle-arrow-17.svg'
import { Rect } from 'modules/shares/types'

const MIN_SYMBOL_NAME_WITDH = 60

const SymbolContainer = styled.div<{ frame: Rect }>(
  ({ theme, frame }) => css`
    position: absolute;
    top: ${frame.y}px;
    left: ${frame.x}px;
    width: ${frame.width}px;
    height: ${frame.height}px;
    border: 2px solid ${theme.colors.purple};
    background: ${rgba(theme.colors.purple, 0.2)};
  `
)

/* Show symbol name on top, truncated if needed */
const SymbolNameContainer = styled.div<{
  frame: Rect
  isLongName?: boolean
}>(
  ({ theme, isLongName, frame }) => css`
    display: flex;
    align-items: flex-end;

    min-width: ${MIN_SYMBOL_NAME_WITDH}px;
    height: 20px;

    position: absolute;
    top: -22px;
    z-index: 1; /* Symbol name will be placed above measurements, it's needed to be able to link to symbol */

    line-height: 1.25;
    font-size: 0.75rem;
    font-weight: ${theme.fontWeights.medium};
    letter-spacing: 0.07px;

    color: ${theme.colors.white};

    /* Rounded right border */
    ${!isLongName &&
    css`
      ::after {
        content: '';
        display: ${frame.width < MIN_SYMBOL_NAME_WITDH && 'none'};
        width: 4px;
        height: 4px;
        border-bottom-left-radius: 4px;
        box-shadow: -1px 1px 0px 1px ${theme.colors.purple};
      }
    `}
  `
)

const SymbolLabel = styled.div<{
  width?: number
}>(
  ({ theme, width }) => css`
    display: inline-flex;
    align-items: center;
    padding: 0 4px;
    max-width: ${width ? `${width}px` : '100%'};
    background: ${theme.colors.purple};
    border-radius: 4px 4px 0 0;
    height: 17px;
    color: ${theme.colors.white};
  `
)

const StyledVersionLink = styled.div`
  width: 17px;
  height: 17px;
  flex: 0 0 17px;
  margin: 0 -2px 0 2px; /* stylelint-disable-line scales/space */
  color: ${({ theme }) => theme.colors.text.dark.secondary};
`

export {
  SymbolContainer,
  SymbolIcon,
  StyledVersionLink,
  SymbolNameContainer,
  SymbolLabel,
}
